import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Stack } from 'syf-component-library/ui/spacing';
import Alert from '../../components/Alert';
import { BoldText, DeliveryDetails, Note, RequestDetails, SummaryHeading } from '../../components/SummaryDetails';
import useFeatureFlagsQuery from '../../hooks/useFeatureFlagsQuery';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import { t } from '../../translations/getTranslation';
import useCardholders from '../../hooks/useCardholders';
const BodyWrapper = styled.div `
  padding: ${({ theme }) => theme.spacing.base}px;
  padding-bottom: ${({ theme }) => theme.spacing.large}px;

  @media ${query.greaterThanMedium} {
    padding: ${({ theme: { spacing } }) => `${spacing.xlarge}px ${spacing.huge}px`};
  }
`;
export const ReviewNeverReceived = () => {
    const { data: featureFlags } = useFeatureFlagsQuery();
    const { accountName, isSuccess, isSemu } = useAccountSummary();
    useAnalytics(isSuccess, {
        isSemu
    });
    const { selectedCardholders } = useCardholders('SelectCardholder');
    return (_jsxs(_Fragment, { children: [_jsx(SummaryHeading, {}), _jsxs(BodyWrapper, { children: [_jsxs(Alert, Object.assign({ variant: "info" }, { children: [t('summaryDetails.onceYouSubmit7days'), _jsx(BoldText, { children: t('summaryDetails.allowUp') }), t('summaryDetails.forYourAccount')] })), _jsx(Stack, { size: "large" }), _jsx(RequestDetails, { accountName: accountName || '', cardholders: selectedCardholders }), _jsx(Stack, { size: "large" }), (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.config.flags.showNote) && (_jsxs(_Fragment, { children: [_jsx(Note, { noteMessage: t('summaryDetails.noteWithUpdate') }), _jsx(Stack, { size: "large" })] })), _jsx(DeliveryDetails, {})] })] }));
};
//# sourceMappingURL=NeverReceived.js.map